import React from 'react';
import {Outlet} from "react-router-dom";

const VehiclesManager = () => {
    return <Outlet />;
};

export default VehiclesManager;